import $ from 'jquery';
import AOS from 'aos';

$(() => {
	AOS.init({
		offset: 270,
		delay: 80, 
		duration: 450,
		easing: 'ease-in-out'
	})
});
